import I18n from 'I18n';
import { useMemo } from 'react';

export interface UmbrellaCollection {
  collectionIds: Array<number | undefined>; // array of collection ids (legacy path)
  collectionSlugs?: string[]; // sub-collection slugs, ordered (Discovery Studio path)
  slug: string; // page url slug
  title: string; // translated page title
  description: string; // translated page description
  htmlPageTitle?: string; // SEO page title (falls back to title if absent)
  metaDescription?: string; // SEO meta description (falls back to description if absent)
}

export interface UmbrellaCollectionResponse {
  collections: UmbrellaCollection[];
}

// Mock data that differentiates between qa/prod environments
function getMockUmbrellaCollections(): UmbrellaCollection[] {
  return [
    {
      slug: 'ai-essentials',
      title: I18n.text(
        'marketplaceStorefront.umbrellaCollections.aiEssentials.title'
      ),
      description: I18n.text(
        'marketplaceStorefront.umbrellaCollections.aiEssentials.description'
      ),
      htmlPageTitle: I18n.text(
        'marketplaceStorefront.umbrellaCollections.aiEssentials.htmlPageTitle'
      ),
      metaDescription: I18n.text(
        'marketplaceStorefront.umbrellaCollections.aiEssentials.metaDescription'
      ),
      collectionIds: [],
      collectionSlugs: ['hubspot-connectors', 'partner-connectors'],
    },
  ];
}

export function useUmbrellaCollections() {
  const mockData = useMemo(() => {
    return {
      collections: getMockUmbrellaCollections(),
    };
  }, []);

  // For now, we return the mock data
  // Later this can be replaced with a DFC query
  return {
    data: mockData,
    loading: false,
    error: undefined,
    getUmbrellaCollectionBySlug: (slug: string) => {
      return mockData.collections.find(
        (collection) => collection.slug === slug
      );
    },
  };
}
